let Brand = /*#__PURE__*/function (Brand) {
  Brand["PACKLINK_PRO"] = "PACKLINK_PRO";
  Brand["PACKLINK_COM"] = "PACKLINK_COM";
  Brand["EBAY"] = "EBAY";
  Brand["PAYPAL"] = "PAYPAL";
  Brand["DPD"] = "DPD";
  return Brand;
}({});

export { Brand };
//# sourceMappingURL=Brand.js.map
